import {
  normalizeVaultPassphrase,
  utf8ToBytes,
  base64ToBytes,
  ensureUint8Array,
} from './vaultCryptoUtils';
import {
  SENSITIVE_VAULT_KDF,
  SENSITIVE_VAULT_KEY_BYTES,
  SENSITIVE_VAULT_PBKDF2_ITERATIONS,
} from './vaultCryptoConfig';
import { normalizeVaultKdf } from './vaultCryptoUtils';

let derivePbkdf2KeyImpl = null;

export function setDerivePbkdf2KeyImpl(fn) {
  if (typeof fn !== 'function') {
    throw new Error('setDerivePbkdf2KeyImpl requires a function');
  }
  derivePbkdf2KeyImpl = fn;
}

export async function deriveVaultWrappingKey({
  passphrase,
  salt,
  iterations = SENSITIVE_VAULT_PBKDF2_ITERATIONS,
  keyBytes = SENSITIVE_VAULT_KEY_BYTES,
  kdf = SENSITIVE_VAULT_KDF,
}) {
  kdf = normalizeVaultKdf(kdf);

  if (kdf === 'pbkdf2') {
    // handle PBKDF2
  } else {
    throw new Error(`Unsupported vault KDF: ${kdf}`);
  }

  if (!derivePbkdf2KeyImpl) {
    throw new Error('PBKDF2 implementation has not been registered');
  }

  const normalizedPassphrase = normalizeVaultPassphrase(passphrase);
  if (!normalizedPassphrase) {
    throw new Error('Passphrase is required');
  }

  const saltBytes =
    typeof salt === 'string' ? base64ToBytes(salt) : ensureUint8Array(salt);

  if (!saltBytes.length) {
    throw new Error('Salt is required');
  }

  const passphraseBytes = utf8ToBytes(normalizedPassphrase);

  const derived = await derivePbkdf2KeyImpl({
    passphraseBytes,
    saltBytes,
    iterations,
    keyBytes,
  });

  const key = ensureUint8Array(derived);

  if (key.length !== keyBytes) {
    throw new Error(
      `Derived key length ${key.length} did not match expected ${keyBytes}`
    );
  }

  return key;
}
